import { ActionReducerMap } from '@ngrx/store';
import * as MyProfileFetchReducer from './my-profile-load.reducer';
import { tableReducer } from './update-table.reducer';
import { legalEntityReducer } from './load-all-legalentity.reducer';
import { myReducer } from './request-access.reducer';

export const customReducers: ActionReducerMap<any> = {
  fetch: MyProfileFetchReducer.myProfileReducer,
  requestAccessBtn: myReducer,
  updateTableState: tableReducer,
  legalEntity: legalEntityReducer
};